import * as React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ArrowLeftIcon = ({ width = 32, height = 32, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    focusable="false"
    {...props}
  >
    <path
      d="M10.6658 10.667L6.27529 15.0575C5.75459 15.5782 5.75459 16.4224 6.27529 16.9431L10.6658 21.3337M6.66581 16.0003L25.3325 16.0003"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

ArrowLeftIcon.displayName = 'ArrowLeftIcon'
